module.exports = __webpack_public_path__ + "static/media/invalid.d14d5cbe.png";